import React from 'react'
import ProjectStep from "../components/ProjectStep";
import Project from "../../../models/Project";
import NavTabs from "../../../components/nav/NavTabs";
import ServiceOverviewSection from "../../services/ServiceOverviewSection";
import Service from "../../../models/Service";
import Modal from "../../../components/Modal";
import Form from "../../../components/form/Form";
import ReviewProjectScope from "../../project-bidding/components/ReviewProjectScope";


const Tab = {
    Details: 'details',
    Scope: 'scope',
    Positions: 'positions',
};

export default class ReviewStep extends ProjectStep {

    static TranslationKey = 'review_step';
    static path = '/review';
    static slug = 'review';

    // static HideNavbar = true;

    static FormClass = 'wizard-form-step wizard-review-step';
    static WrapperClass = 'review-step-container';

    static HandleUnauthorized = false;
    static InlineFormActions = true;

    static ValidationMethodName = 'validateReview'

    /**
     * The continue & back buttons
     */
    static showFormButtons() {
        return true
    }

    /**
     * The subtitle shown on the form
     */
    static get StepSection() {
        return Project.ProjectSections.SectionReview;
    }

    getStepSubtitle() {
        return this.constructor.StepSection;
    }

    static hasCompleted(project) {
        return {
            setup_at: (new Date()).toISOString()
        };
    }

    /**
     * @param {Project} project
     * @param auth
     * @returns {Object}
     */
    static reviewMapping(project, auth = undefined) {
        return false
    }

    constructor(props, context) {
        super(props, context);

        this.modalRef = React.createRef();

        let tabKeys = [
            Tab.Details,
        ];
        if (this.props.project.isService()) {
            tabKeys.push(Tab.Scope);
        } else if (this.props.project.isBYO()) {
            tabKeys.push(Tab.Positions);
        }

        let tabs = TB.map(tabKeys, key => {

            let title = this.translate(`${key}_section_title`).toUpperCase();
            return {
                title,
                value: title
            }
        });

        this.state = {
            ...this.state,
            tabs,
            activeTab: TB.first(tabs),
            isMobile: TB.isMobile()
        }
    }

    componentDidMount() {
        super.componentDidMount();

        if (!this.props.project.canEditScope() && (
            this.props.location?.state?.fromBidding || this.props.queryParams?.fromBidding
        )) {
            TB.sysAlert('team_shopping.project_summary_view_tab_visit_tip')
        }
    }

    shouldHandleSubmit(project) {
        return true;
    }

    async onSubmit(params) {
        return this.props.completeWizard();
    }

    goToStep(step) {
        this.props.goToStep(step, {review: 1});
    }

    renderDetailQuestionsTable() {
        let project = this.props.project;
        // console.log(this.props.steps);

        let formSteps = TB.filter(project.currentSteps(), step => step.StepSection === Project.ProjectSections.SectionProfile ||
            step.StepSection === Project.ProjectSections.SectionType
        );

        return formSteps.map((step, si) => {

            let fields = step.reviewMapping(project, this.context.auth);

            if (!fields || !Object.keys(fields).length) {
                return null;
            }

            return TB.map(fields, (Fields, stepLabel) => {

                if (stepLabel === 'Project Name') {
                    stepLabel = 'Project Name and Ownership';
                }

                return (
                    <div key={`detail-steps-${si}`}
                         className={"review-item"}>

                        <p className="review-item-title">
                            {stepLabel}
                        </p>

                        <div className="review-item-section">
                            <div className={"review-item-info"}>
                                {(!TB.isObject(Fields) || TB.isElement(Fields)) ? (
                                    <p className={"review-item-label"}>
                                        {Fields}
                                    </p>
                                ) : TB.map(Fields, (propValue, propLabel) => {
                                    let key = `detail-steps-${si}-fields-${propLabel}`;


                                    if (!propValue || TB.isObject(propValue)) return (
                                        <div key={key} className={"review-item-label"}/>
                                    )

                                    return (
                                        <p key={key} className={"review-item-label"}>
                                            {propLabel}:
                                            <span className={"review-item-value"}>{propValue}</span>
                                        </p>
                                    );
                                })}
                            </div>

                            <div className={"review-item-action"}>
                                {
                                    project.canEditScope() && (
                                        <button onClick={() => {
                                            this.props.navigate({
                                                pathname: step.getPath(project),
                                                search: '?fromReview=true'
                                            }, {state: {fromReview: true}})
                                        }}
                                                className="btn btn-link">

                                            {this.translate('edit_detail_btn')}

                                        </button>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                )
            });
        });
    }

    toggleShowScopeInfo() {
        this.setState({
            showScopeInfo: !this.state.showScopeInfo
        });
    }

    renderScopeQuestionsTable() {
        return <ReviewProjectScope className="table-bordered "/>
    }

    toggleShowPositionInfo() {
        this.setState({
            showPositionInfo: !this.state.showPositionInfo
        });
    }

    renderPositionsTable() {
        let positions = this.props.project.sortedPositions(

        );
        if (!positions || !positions.length) {
            return <div/>;
        }

        return (
            <div>

                <div className="text-left table-responsive mt-5">
                    <table className="table table-bordered mb-0"
                           style={{marginBottom: '-1px!important'}}>
                        <tbody>
                        {positions.map((position, positionIndex) => {
                            return (
                                <tr key={`project-positions-${positionIndex}`} className="bg-white">

                                    <td className="p-4 position-review-item flex flex-col gap-2.5">

                                        <p className="title-label">
                                            {position.title?.toUpperCase()}
                                        </p>
                                        <p className="position-time-range">
                                            <span className="radio-checked"/>
                                            {position.timeRange(' to ')}
                                        </p>
                                        <div className="position-name-row">
                                            <div
                                                className="flex flex-row flex-wrap justify-start items-start self-stretch gap-2">
                                                {TB.map(position.templates, template => (
                                                    <div key={template.name}
                                                         className="flex justify-start items-center relative gap-2.5 px-2 py-0.5 rounded-xl bg-[#5f3db1]">
                                                        <p className="whitespace-nowrap text-[10px] font-medium text-left text-white">
                                                            {template.name}
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>


                                    </td>
                                    {!position.proposal_requested_at && !this.props.project.hasRequestedSOW() && (
                                        <td className="actions-cell"
                                            style={{verticalAlign: 'middle', border: '1px solid #E5EBF1'}}>

                                            {!position.proposal_requested_at && !position.has_candidates && (
                                                <button onClick={() => {
                                                    this.props.navigate({
                                                        pathname: `role/${position.id}`,
                                                        search: '?fromReview=true'
                                                    }, {state: {fromReview: true}})
                                                }} className="btn btn-link px-2">
                                                    {this.translate('edit_position_btn')}
                                                </button>
                                            )}

                                            {this.props.project.canDeletePosition(position) && (
                                                <button type="button"
                                                        className="btn btn-link px-2"
                                                        onClick={async () => {
                                                            let shouldDelete = await TB.sysAlert('byo.delete_role_button_clicked');

                                                            if (shouldDelete) {
                                                                await this.props.toggleDisabled(true)

                                                                try {
                                                                    let updatedProject = await this.props.project.deletePosition(
                                                                        position
                                                                    )
                                                                    if (!updatedProject) return;

                                                                    await this.props.toggleDisabled(false)

                                                                    return this.props.updateProject(updatedProject);
                                                                } catch (e) {
                                                                    await this.props.toggleDisabled(false)
                                                                }
                                                            }
                                                        }}>
                                                    Remove
                                                </button>
                                            )}
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    viewSummaryTab(tab) {
        this.setState({
            activeTab: tab
        });
    }

    activeSummaryTab() {
        if (!this.state.activeTab) {
            return TB.first(this.state.tabs);
        }
        return this.state.activeTab;
    }

    isShowingDetails() {
        return this.isShowingTab(
            Tab.Details
        );
    }

    isShowingScopeQuestions() {
        if (this.props.project.isBYO()) {
            return false;
        }

        return this.isShowingTab(
            Tab.Scope
        );
    }

    isShowingPositions() {
        if (this.props.project.isService()) {
            return false;
        }

        return this.isShowingTab(
            Tab.Positions
        );
    }

    isShowingTab(key) {
        let activeTab = this.activeSummaryTab().title;

        return activeTab === this.translate(
            `${key}_section_title`
        ).toUpperCase()
    }

    renderFormHeader() {
        return (
            <div className={
                TB.mapClass({"project-review-step": true, "no-edit": this.props.isDisabled})}>


                <div className="d-hidden show-tabs-mobile">
                    <NavTabs
                        // hideTabs={true}
                        tabs={this.state.tabs}
                        active={this.state.activeTab}
                        onChange={this.viewSummaryTab.bind(this)}
                    />
                </div>

                <div className="project-review-container flex-col">

                    <div className="bg-white flex flex-col items-stretch">
                        <div className="flex review-tabs">
                            <div className={TB.mapClass("review-tab-section pt-4", {
                                'active-review-tab': this.isShowingDetails()
                            })}>
                                <label className="review-tab-title mb-8">
                                    {this.translate('details_section_title').toUpperCase()}
                                </label>
                                {this.renderDetailQuestionsTable()}
                            </div>

                            {this.props.project.isService() && (
                                <div className={TB.mapClass("review-tab-section bg-[#F8F9FB] pt-4", {
                                    'active-review-tab': this.isShowingScopeQuestions()
                                })}>
                                    <label className="review-tab-title mb-8">
                                        TEAM BLUEPRINT
                                    </label>
                                    {this.renderScopeQuestionsTable()}
                                </div>
                            )}

                            {this.props.project.isBYO() && (
                                <div className={TB.mapClass("review-tab-section pt-4", {
                                    'active-review-tab': this.isShowingPositions()
                                })}>

                                    <label className="review-tab-title mb-8" style={{letterSpacing: '0.29em'}}>
                                        {this.translate('positions_section_title').toUpperCase()}
                                    </label>
                                    {this.renderPositionsTable()}

                                    <div className="clearfix"/>
                                    <div className="mt-4 mb-4 p-4">
                                        {this.props.project.isBYO() &&
                                            !this.props.project.hasRequestedSOW() && (
                                                <button
                                                    onClick={async () => {
                                                        if (this.props.project.sortedPositions().length >= Project.maxAllowedPositions()) {
                                                            return TB.sysAlert('byo.add_role_button_clicked_max_roles')
                                                        }

                                                        let positionIndex = this.props.project.sortedPositions().length;
                                                        await this.onChange({positions_count: positionIndex + 1})

                                                        // await this.props.refresh(Project.make({...this.props.project}));

                                                        this.props.navigate({
                                                            key: TB.uuid(),
                                                            pathname: "role/new",
                                                            search: '?fromReview=true'
                                                        }, {
                                                            state: {
                                                                newPosition: true,
                                                                fromReview: true
                                                            }
                                                        });

                                                    }}
                                                    disabled={this.props.isDisabled} className="btn btn-primary">
                                                    Add Position
                                                </button>
                                            )}
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="review-form-actions px-4 py-3">
                            {this.props.children}
                        </div>

                    </div>


                </div>
            </div>
        )
    }

    async reloadService(service) {
        clearTimeout(this.serviceFetchTimeout)
        this.serviceFetchTimeout = setTimeout(async () => {
            try {
                let fullService = await Service.fetch(service.id);

                if (!fullService) {
                    let error = await this.constructor.parseRequestError(
                        Service.GetRequest, {
                            500: 'error_show_service',
                            404: 'error_service_not_found',
                        }
                    );

                    return this.promisedState({serviceError: error})
                }

                await this.promisedState({
                    service: fullService,
                    serviceError: null
                })
            } catch (e) {
                console.warn('ERROR: Service Overview', e);
                let error = await this.constructor.parseRequestError(
                    Service.GetRequest, {
                        500: 'error_show_service',
                        404: 'error_service_not_found',
                    }
                );

                this.promisedState({serviceError: error})
            }
        })
    }

    renderTitle() {
        return (
            <div className={"step-title-container"}>
                {this.getStepTitle() && (
                    <h4 className="step-title">
                        <span>
                            {this.getStepTitle()}
                        </span>
                        {this.props.project.isService() && this.props.project.service && (
                            <span className="step-title-link" onClick={async () => {
                                if (!this.modalRef.current) return;
                                this.modalRef.current.showModal({
                                    modalClass: 'project-review',
                                    title: 'Project Overview: ' + this.getStepTitle()
                                })
                                return this.reloadService(this.props.project.service)
                            }}>See Details</span>
                        )}
                    </h4>
                )}
                {this.getStepSubtitle() && (
                    <h1 className="step-section">{this.getStepSubtitle()}</h1>
                )}

            </div>
        )
    }


    renderFormFooter() {

        let components = [
            // (
            //     <button onClick={this.props.completeWizard} className="my-4 mx-auto btn btn-primary">
            //         Continue
            //     </button>
            // )
        ];

        if (!this.props.project.isBYO()) {
            // components.push((
            //     <div key={"scope-estimate"} className="create-project-scope-estimate">
            //         <WrippleEstimate
            //             id={"create-project-review-estimate"}
            //             trans={this.translate.bind(this)}
            //             project={this.props.project}
            //             isDisabled={this.props.isDisabled}
            //             onContinue={this.props.project.canEditScope() ? this.props.completeWizard : undefined}
            //         />
            //     </div>
            // ));

            if (this.props.project.service) {
                components.push((
                    <Modal key={'service-modal'} ref={this.modalRef}>
                        <ServiceOverviewSection
                            service={this.state.service || this.props.project.service}
                            error={this.state.serviceError}
                            onRetry={() => this.reloadService(this.props.project.service)}
                            expandForModal={false}/>
                    </Modal>
                ))
            }
        }
        return components
    }

    /**
     * Render the form
     *
     * @returns JSX.Element
     */
    render() {
        let {formOnly} = this.props;
        let fields = this.generateFormFields();

        return (
            <div className="project-team-step wizard-form-step max-w-screen-lg px-2">
                {this.renderFormHeader()}

                {fields.length > 0 && (
                    <Form
                        ref={this.formRef}
                        showRequired
                        title={null}
                        subtitle={null}
                        submitButton={false}
                        onSubmit={null}
                        background={this.constructor.FormBg}
                        model={this.props.project}
                        mapping={model => this.mapping(model)}
                        onChange={this.onChange.bind(this)}
                        fields={fields}
                        isDisabled={this.props.isDisabled}>

                    </Form>
                )}
                {!formOnly && this.renderFormFooter()}
            </div>
        )
    }
}